import React from "react";

import { Box, Typography } from "@mui/material";

import { ReactComponent as CnvSvg } from "assets/images/homepage/mutations/cnvs.svg";
import { ReactComponent as ExpressionSvg } from "assets/images/homepage/mutations/expression.svg";
import { ReactComponent as FusionSvg } from "assets/images/homepage/mutations/fusions.svg";
import { ReactComponent as IndelSvg } from "assets/images/homepage/mutations/indels.svg";
import { ReactComponent as MsiAnalysisSvg } from "assets/images/homepage/mutations/msi_analysis.svg";
import { ReactComponent as SnvsSvg } from "assets/images/homepage/mutations/snvs.svg";
import { ReactComponent as SplicingSvg } from "assets/images/homepage/mutations/splicing.svg";
import { ReactComponent as TmbSvg } from "assets/images/homepage/mutations/tmb.svg";

interface MutationsItemProps {
  title: string;
  MutationIcon: React.FC<React.SVGProps<SVGSVGElement>>;
}

const MutationsList: MutationsItemProps[] = [
  {
    title: "SNVs",
    MutationIcon: SnvsSvg,
  },
  {
    title: "Indels",
    MutationIcon: IndelSvg,
  },
  {
    title: "CNVs",
    MutationIcon: CnvSvg,
  },
  {
    title: "Fusions",
    MutationIcon: FusionSvg,
  },
  {
    title: "Splicing",
    MutationIcon: SplicingSvg,
  },
  {
    title: "Expression",
    MutationIcon: ExpressionSvg,
  },
  {
    title: "MSI",
    MutationIcon: MsiAnalysisSvg,
  },
  {
    title: "TMB",
    MutationIcon: TmbSvg,
  },
];

export const MutationList = () => (
  <Box
    display="flex"
    flexDirection="column"
    gap={{ xs: "18px", sm: "24px", md: "32px" }}
  >
    <Typography variant="h3" align="center">
      Supported Mutations
    </Typography>

    <Box
      display="flex"
      columnGap={5}
      rowGap={1}
      justifyContent={{ xs: "center", md: "space-between" }}
      flexWrap="wrap"
      component="ul"
      margin={0}
    >
      {MutationsList.map(({ MutationIcon, title }: MutationsItemProps) => (
        <Box
          key={title}
          className="mutation-item"
          width={80}
          height={95}
          component="li"
        >
          <MutationIcon />
          <Box position="relative" top={-8}>
            <Typography
              variant="h5"
              component="span"
              display="block"
              align="center"
            >
              {title}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  </Box>
);
